module.exports = __webpack_public_path__ + "static/media/homeSVG.f4502ccd.svg";